import React from "react";
import './WhyContainer.css';
import { useNavigate } from "react-router-dom";
import { useAuth } from '../AuthContext';
import { useSubscription } from '../SubscriptionContext';
import { FaCheckCircle, FaLightbulb, FaBullseye } from "react-icons/fa";

const WhyContainer = () => {
  const { user, signInWithGoogle } = useAuth();
  const { canGenerateQuestions } = useSubscription();
  const navigate = useNavigate();

  // Function to navigate to pricing section
  const navigateToPricing = () => {
    navigate('/');
    setTimeout(() => {
      const pricingSection = document.getElementById('pricing');
      if (pricingSection) {
        pricingSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 100);
  };

  const handleExplorePlatform = () => {
    if (user) {
      // Check if authenticated user can generate questions
      if (canGenerateQuestions()) {
        navigate('/dashboard');
      } else {
        // User has reached their limit, redirect to pricing
        navigateToPricing();
      }
    } else {
      signInWithGoogle();
    }
  };
  return (
    <div className="pain-section" id="pain-elimination">
      <h2>Why Engineers Choose LeetEngineer?</h2>
      <div className="pain-points">
        <div className="pain-point">
          <div className="icon-wrapper">
            <FaCheckCircle className="why-react-icon" />
            <h3>Unpredictable Interviews</h3>
          </div>
          <p>Our AI generates role-specific questions from job postings, eliminating guesswork and preparing you for real interviews.</p>
        </div>
        <div className="pain-point">
          <div className="icon-wrapper">
            <FaLightbulb className="why-react-icon" />
            <h3>Scattered Preparation</h3>
          </div>
          <p>Get structured visual technical questions, HR screening prep, and instant answer guides tailored to your engineering field.</p>
        </div>
        <div className="pain-point">
          <div className="icon-wrapper">
            <FaBullseye className="why-react-icon" />
            <h3>Resume Building Struggle</h3>
          </div>
          <p>Create professional resumes from scratch or perfectly tailored to specific job posts, showcasing your engineering expertise.</p>
        </div>
      </div>
      <button onClick={handleExplorePlatform} className='explore'>Explore Platform Now</button>
    </div>
  );
};

export default WhyContainer;